<template>
  <div class="mobile-background" ref="mobileBackground">
    <div class="mobile-content-container">

      <div class="upper-container" @click="redirectToDrc()">
        <div class="landing-content">
          <h1>{{ $t('landingPage.drc') }}</h1>
          <div class="landing-text">{{ $t('landingPage.drcDescription') }}</div>
          <button class="example">{{ $t('landingPage.exploreDrc').toUpperCase() }}</button>
        </div>
      </div>
      <div class="lower-container" @click="redirectToGop()">
        <div class="landing-content">
          <h1>{{ $t('landingPage.gop') }}</h1>
          <div class="landing-text">{{ $t('landingPage.gopDescription') }}</div>
          <button>{{ $t('landingPage.exploreGop').toUpperCase() }}</button>
        </div>
      </div>

    </div>
    <Newsletter/>
  </div>
</template>
<script>
import Newsletter from "@/common/pages/landing/Newsletter.vue";

export default {
  name: "MobileLanding",
  components: {Newsletter},
  mounted() {
    const img = require(`@/common/assets/images/mobile-background.webp`);
    this.$refs.mobileBackground.style.backgroundImage = `url(${img})`;
  },
  methods: {
    redirectToDrc() {
      this.$router.push('/home');
    },
		redirectToGop() {
			this.$router.push('/gop/home');
		}
  }
}
</script>

<style scoped lang="scss">
@import "@/common/assets/css/_variables.scss";
.mobile-background {
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .mobile-content-container {
    display: flex;
    flex-direction: column;
    height: 90dvh;

    .lower-container, .upper-container {
      margin: 10vh;
    }

    .upper-container {
      flex: 4;
      button {
        background: linear-gradient(135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 9%, rgba(255, 184, 28, 1) 9%, rgba(255, 184, 28, 1) 100%);
      }
    }

    .lower-container {
      flex: 6;
      text-align: right;
      button {
        background: linear-gradient(135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 9%, rgba(0, 255, 255, 1) 9%, rgba(0, 255, 255, 1) 100%);
      }
    }

    h1 {
      font-family: Tiempos Text, serif;
      font-size: 3vh;
      font-weight: 400;
      line-height: 4vh;
      letter-spacing: 0.38px;
      color: $color-white-light;

    }

    .landing-text {
      font-family: Roboto, serif;
      font-size: 2vh;
      font-weight: 400;
      line-height: 3vh;
      letter-spacing: 0.35px;
      color: $landing-text-color;
    }
    button {
      position: relative;
      border: none;
      padding: 1.5vh 3.5vw;
      color: $color-black;
      font-weight: bold;
      font-size: 2vh;
      margin-top: 3vh;
      cursor: pointer;
      transition: all 0.5s ease-in-out;
      text-transform: capitalize;

      &:after {
        content: '';
        position: absolute;
        width: 2.5vh;
        height: 2.5vh;
        top: -1vh;
        left: -1vh;
        cursor: default;
        transform: rotate(45deg);
      }
    }
  }
}
@media (max-aspect-ratio: 9/15) {
  .mobile-background {
    .mobile-content-container {
      .upper-container {
        margin: 10vh 5vw 5vh 5vw;
      }
      .lower-container{
        margin: 5vh 5vw;
      }
    }
  }
}


</style>
